import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const teamDynamix = defineConnector({
  identifier: "teamDynamix",
  name: "TeamDynamix",
  tagLine: "IT service and asset management",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(
      baseUrl || "https://your-tenant.teamdynamix.com/TDWebApi/api"
    ),
  auth: ({ configuration }) =>
    fetchTokenAuth({
      request: {
        url: {
          from: "literal",
          value:
            (
              configuration.baseUrl ||
              "https://your-tenant.teamdynamix.com/TDWebApi/api"
            )
              .trim()
              .replace(/\/+$/, "") + "/auth",
        },
        headers: [
          {
            name: "Content-Type",
            value: { from: "literal", value: "application/json" },
          },
        ],
        jsonBody: {
          username: { from: "config", field: "username" },
          password: { from: "secret", field: "password" },
        },
      },
      extract: { from: "jsonPath", paths: ["token"], fallbackToRawBody: true },
      apply: {
        kind: "header",
        name: "Authorization",
        scheme: "Bearer",
        extraHeaders: [],
      },
    }),
  steps: [
    {
      title: "Set up TeamDynamix",
      items: [
        {
          kind: "markdown",
          content:
            "Ask your TeamDynamix administrator for a Web API account with the required read permissions. Enter your tenant API URL and account credentials below. See the [Web API authentication reference](https://solutions.teamdynamix.com/TDWebApi/swagger).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "url",
          label: "API base URL",
          required: true,
          placeholder: "https://your-tenant.teamdynamix.com/TDWebApi/api",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "Use your organization’s TeamDynamix tenant host in place of `demotemplate.teamdynamix.com`, then append `/TDWebApi/api`. The web console URL is separate; do not use its `/tdapp/account/login` path as the API base URL.",
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: {
            kind: "configuration",
            field: "username",
          },
          helperText:
            "The username for an authorized TeamDynamix Web API login or Web API Auth Account.",
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: {
            kind: "secrets",
            field: "password",
          },
          helperText:
            "The password for the authorized TeamDynamix Web API login or Web API Auth Account.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://your-tenant.teamdynamix.com/TDWebApi/api")
          .trim()
          .replace(/\/+$/, "") + "/auth/getuser",
      ...{ method: "GET", headers: { "Content-Type": "application/json" } },
    }),
  },
});
